// Salg (no).
window.PlummeI18n.register('no', {
  'adv.sales.productsShowMore': 'Vis mer',
  'adv.sales.productsNote': 'Beløpet under Størst omsetning er fakturert salg per produkt i valgt år. Vekst og fall viser prosentvis endring i omsetning fra samme produkt året før. Produkter uten sammenlignbare fjorårstall vises ikke under vekst og fall.',
  'adv.sales.productsPage': 'Side {page} av {pages}',
  'adv.sales.productsPrevious': 'Forrige side for {label}',
  'adv.sales.productsNext': 'Neste side for {label}',
  'adv.sales.scn.adjust.priceUp': 'Prisøkning',
  'adv.sales.scn.adjust.volumeDown': 'Fall i salgsvolum',
  // ------------------------------------------------------------- Nytt salg
  'sale.doc.invoice': 'Ny faktura',
  'sale.doc.quote': 'Nytt tilbud',
  'sale.doc.orderConfirmation': 'Ny ordrebekreftelse',
  'sale.doc.creditNote': 'Ny kreditnota',
  'sale.doc.other': 'Annet salg',
  'sale.howToCreate': 'Hvordan vil du lage {document}?',
  'sale.docIndefinite.invoice': 'en faktura',
  'sale.docIndefinite.quote': 'et tilbud',
  'sale.docIndefinite.orderConfirmation': 'en ordrebekreftelse',
  'sale.docIndefinite.creditNote': 'en kreditnota',
  'sale.docIndefinite.other': 'et annet salg',
  'sale.credit.title': 'Kreditering',
  'sale.credit.help': 'En kreditnota reverserer et salg. Beløpene skrives inn positivt som på en faktura — Plumme snur fortegnet i bokføringen, så salgsinntekt og utgående MVA reduseres og kundefordringen krediteres.',
  'sale.credit.reason': 'Årsak til kreditering',
  'sale.credit.reasonHint': 'Påkrevd. Grunnlaget skal vise hva som faktisk skjedde, ikke bare beløpet.',
  'sale.credit.reasonPh': 'Retur av vare, prisavslag, feilfakturering ...',
  'sale.credit.link': 'Koble til faktura',
  'sale.credit.linkHint': 'Valgfritt. Kobler du til, hentes fakturanummeret automatisk og kreditnotaen motregnes mot fakturaens utestående.',
  'sale.credit.linkNone': 'Ingen kobling – fritt tilgodebeløp',
  'sale.credit.linkSearchPh': 'Søk på fakturanummer, kunde eller beløp ...',
  'sale.credit.linkNoMatches': 'Ingen fakturaer matcher søket',
  'sale.credit.linkShowMore': 'Vis flere fakturaer',
  'sale.credit.invoiceOption': 'Faktura {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Valgt fra fakturaen',
  'sale.credit.noNumber': 'Uten nummer',
  'sale.credit.reference': 'Gjelder (opprinnelig salg)',
  'sale.credit.referenceHint': 'Påkrevd uten fakturakobling. Oppgi fakturanummer, avtale, periode eller system salget lå i.',
  'sale.credit.referencePh': 'F.eks. faktura 1042 eller «avtale 2025-04»',
  'sale.credit.linkedTo': 'Krediterer faktura {document}',
  'sale.credit.offsetBadge': 'Motregnes automatisk',
  'sale.credit.freeHint': 'Uten kobling blir beløpet stående som kundens tilgodebeløp. Du kan motregne det mot en faktura eller betale det tilbake fra fakturalisten.',
  'sale.credit.date': 'Kreditnotadato',
  'sale.credit.numberLabel': 'Kreditnotanr.:',
  'sale.credit.amount': 'Beløp til gode',
  'sale.credit.previewNote': 'Beløpet er kreditert. Det motregnes mot utestående eller betales tilbake.',
  'sale.credit.previewReason': 'Årsak:',
  'sale.credit.previewReference': 'Gjelder:',
  'sale.credit.set': 'Angi detaljer',
  'sale.credit.edit': 'Endre',
  'sale.credit.missing': 'Årsak og referanse til opprinnelig salg må være angitt før kreditnotaen kan opprettes.',
  'sale.credit.noReference': 'Ingen referanse oppgitt',
  'sale.credit.freeBadge': 'Fritt tilgodebeløp',
  'sale.credit.needReason': 'Skriv årsaken til krediteringen først',
  'sale.credit.needReference': 'Koble til en faktura eller oppgi hvilket opprinnelig salg kreditnotaen gjelder',
  'sale.credit.needDetails': 'Angi årsak og koble til en faktura eller oppgi det opprinnelige salget først',
  'sale.credit.create': 'Opprett kreditnota',
  'sale.det.period': 'Periode',
  'sale.det.subscriptionFrom': 'Abonnement fra',
  'sale.det.subscriptionTo': 'Abonnement til',
  'sale.det.rentFrom': 'Leie fra',
  'sale.det.rentTo': 'Leie til',
  'sale.lines.descShortPh': 'F.eks. konsulenttime eller abonnement',
  'sale.from': 'Fra',
  'sale.to': 'Til',
  'sale.use': 'Bruk',
  'sale.swap': 'Bytt',
  'sale.show': 'Vis',
  'sale.edit': 'Rediger',
  'sale.download': 'Last ned',
  'sale.send': 'Send',
  'sale.add': 'Legg til',
  'sale.save': 'Lagre',
  'sale.saveChanges': 'Lagre endringer',
  'sale.thisSale': 'dette salget',
  'sale.step.kunde': 'Kunde',
  'sale.step.bilag': 'Bilag',
  'sale.step.detaljer': 'Detaljer',
  'sale.step.linjer': 'Linjer',
  'sale.step.forhandsvisning': 'Forhåndsvisning',
  'sale.title': 'Salg / Faktura / Tilbud',
  'sale.titleHelp': 'Registrer salg, lag faktura, tilbud eller ordrebekreftelse',
  'sale.docTypeHelpTitle': 'Dokumenttype',
  'sale.docTypeHelp': 'Velg hva slags salgsdokument du lager. Faktura er et betalingskrav til kunden. Tilbud er et uforpliktende pristilbud. Ordrebekreftelse bekrefter en avtalt bestilling. Annet salg brukes for salg utenfor systemet, der du laster opp et bilag som dokumentasjon.',
  'sale.stepsHelpTitle': 'Stegene i salget',
  'sale.stepsHelp': 'Salget er delt i fire steg: Kunde, Detaljer, Linjer og Forhåndsvisning (for Annet salg: Bilag, Detaljer, Linjer og Forhåndsvisning). Trykk på et steg for å hoppe dit. Et steg merkes om noe mangler før dokumentet kan opprettes.',
  'sale.viewHelpTitle': 'Bytt visning',
  'sale.viewHelpToOnePage': 'Bytter fra den stegvise flyten til én samlet side der alle feltene vises på én gang, ved siden av en levende forhåndsvisning. Raskere når du er vant til skjemaet.',
  'sale.viewHelpToSteps': 'Bytter fra én samlet side til en rolig stegvis flyt der du fyller ut én ting om gangen — kunde, detaljer, linjer og forhåndsvisning. Fint når du vil ha veiledning underveis.',
  'sale.toOnePage': 'Bytt til alt på en side',
  'sale.toSteps': 'Bytt til steg-for-steg',
  'sale.stepByStep': 'Steg for steg',
  'sale.previewHelpTitle': 'Forhåndsvisning',
  'sale.previewHelp': 'Her ser du hvordan det ferdige dokumentet ser ut for kunden — med avsender, kundeinfo, linjer og totalsum. Det oppdateres mens du fyller ut, slik at du kan kontrollere alt før du oppretter eller sender.',
  'sale.previewToggleHelp': 'Viser eller skjuler den levende forhåndsvisningen ved siden av skjemaet. Skjul den om du vil ha mer plass til feltene.',
  'sale.previewHide': 'Skjul forhåndsvisning',
  'sale.previewShow': 'Vis forhåndsvisning',
  'sale.previewHeading': 'Slik ser dokumentet ut',
  'sale.backToVouchers': 'Tilbake til transaksjoner',
  'sale.resetTitle': 'Nullstill skjemaet og start på nytt',
  'sale.reset': 'Nullstill', 'sale.resetDone': 'Skjemaet er nullstilt',
  'sale.back': 'Tilbake',
  'sale.next': 'Neste',
  'sale.draftSaved': 'Utkast lagret',
  'sale.draftSavedHelp': 'Utkastet ligger i fakturalisten slik det står nå. Endrer du noe, kan du lagre på nytt — det oppdaterer det samme utkastet.',
  'sale.saveDraft': 'Lagre utkast',
  'sale.saveDraftHelpTitle': 'Lagre utkast',
  'sale.saveDraftHelp': 'Lagrer salget som et utkast i fakturalisten uten å sende eller opprette det. Du kan fortsette der du slapp senere.',
  'sale.saveDraftHelpLong': 'Lagrer salget som et utkast i fakturalisten uten å sende eller opprette det. Du kan trygt gå fra siden og fortsette der du slapp senere.',
  'sale.saveDraftHelpShort': 'Lagrer salget som et utkast i fakturalisten uten å sende eller opprette det. Du kan trygt gå fra siden og fortsette senere.',
  'sale.drafts': 'Utkast',
  'sale.draftsTitle': 'Påbegynte salg du ikke har opprettet ennå',
  'sale.noDrafts': 'Ingen utkast',
  'sale.searchDrafts': 'Søk i utkast...',
  'sale.deleteDraft': 'Slett utkast',
  'sale.deleteDraftTitle': 'Slette utkast?',
  'sale.deleteDraftBody': 'Er du sikker på at du vil slette utkastet for {customer}? Dette kan ikke angres.',


  'sale.det.help': 'Datoer, referanser og kommentar for dokumentet. Fakturadato/forfallsdato styrer når kravet gjelder og forfaller. «Vår referanse» er saksbehandler hos dere, «Deres referanse» er kundens prosjekt eller kontaktperson. For faktura kan du også slå på repeterende, slik at den sendes automatisk hver periode.',
  'sale.det.date': 'Dato',
  'sale.det.due': 'Forfall',
  'sale.det.ourRef': 'Vår referanse',
  'sale.det.ourRefPh': 'F.eks. saksbehandler hos oss',
  'sale.det.theirRef': 'Deres referanse',
  'sale.det.theirRefPh': 'Deres referanse / prosjekt',
  'sale.det.payTo': 'Betal til',
  'sale.det.payToHelp': 'Bankkontoen kunden skal betale fakturaen til. Listen viser bankkontoene du har lagret — fakturakontoen fra innstillinger er valgt på forhånd, og du kan legge til en ny konto rett herfra.',
  'sale.det.payToDefault': 'Fakturakonto',
  'sale.det.payToEmpty': 'Ingen bankkonto lagret',
  'sale.det.payToAdd': '+ Legg til bankkonto ...',
  'sale.det.comment': 'Kommentar',
  'sale.det.commentPh': 'Valgfri kommentar som vises på dokumentet',
  'sale.det.savedComments': 'Lagrede kommentarer',
  'sale.det.saveComment': 'Lagre kommentar',
  'sale.det.useComment': 'Bruk kommentar',
  'sale.det.noSavedComments': 'Ingen lagrede kommentarer ennå.',
  'sale.det.deliveryFrom': 'Leverings-/utførelsesperiode - Fra',
  'sale.det.deliveryTo': 'Leverings-/utførelsesperiode - Til',
  'sale.det.repeating': 'Repeterende',
  'sale.det.repeatingHelpTitle': 'Repeterende faktura',
  'sale.det.repeatingHelp': 'Slå på for at fakturaen skal sendes automatisk med jevne mellomrom — for eksempel hver måned ved abonnement. Du velger intervall og forfall, så lager Plumme og sender en ny faktura hver periode uten at du trenger å gjøre noe.',
  'sale.det.sentEvery': 'Sendes hver',
  'sale.period.week': 'Uke',
  'sale.period.month': 'Måned',
  'sale.period.quarter': 'Kvartal',
  'sale.period.year': 'Årlig',
  'sale.det.sameDay': 'Samme dag',

  'sale.lines.help': 'Varene og tjenestene på salget. Hver linje har antall, pris, MVA-sats og eventuell rabatt, og linjesummen regnes ut automatisk. Velg et lagret produkt eller skriv fritekst, og dra i håndtaket til venstre for å endre rekkefølgen.',
  'sale.lines.add': 'Legg til linje',
  'sale.lines.product': 'Produkt',
  'sale.lines.productPh': 'Søk eller skriv nytt produkt...',
  'sale.lines.noProductMatch': 'Ingen lagrede produkter matcher',
  'sale.lines.editProduct': 'Rediger produkt',
  'sale.lines.productName': 'Produktnavn',
  'sale.lines.description': 'Beskrivelse',
  'sale.lines.descriptionPh': 'Valgfri beskrivelse av produktet/linjen',
  'sale.lines.qty': 'Antall',
  'sale.lines.vat': 'MVA/moms',
  'sale.lines.discount': 'Rabatt',
  'sale.lines.netSum': 'Linjesum eks. MVA',
  'sale.lines.toggleVat': 'Bytt mellom eks. og inkl. MVA',
  'sale.lines.more': 'Mer',
  'sale.lines.less': 'Mindre',
  'sale.lines.searchAccount': 'Søk konto...',
  'sale.lines.noAccountMatch': 'Ingen kontoer matcher søket.',
  'sale.lines.pickAccount': 'Velg konto',
  'sale.lines.searchProductPh': 'Søk på navn eller beskrivelse...',

  'sale.sum.help': 'Totalen for hele salget: sum eksklusiv MVA, pluss MVA, er lik beløpet kunden skal betale. Tallene oppdateres automatisk når du endrer linjene.',

  'sale.att.title': 'Vedlegg',
  'sale.att.upload': 'Last opp vedlegg',
  'sale.att.drop': 'Dra filer hit',
  'sale.att.dropHint': 'Bilder eller PDF, eller lim inn',
  'sale.att.pickFile': 'Velg fil',
  'sale.att.dropToAdd': 'Slipp vedlegg for å legge det til',
  'sale.att.dragTip': 'Tips: du kan også dra filer rett inn i siden.',
  'sale.att.forgot': 'Har du glemt noen bilag? Slipp bilaget her',
  'sale.att.fromInbox': 'Hent fra innboks',
  'sale.att.uploadInstead': 'Last opp bilag i stedet',
  'sale.att.view': 'Se bilaget',
  'sale.att.openPreview': 'Åpne i forhåndsvisning',

  'sale.send.title': 'Sender dokument',
  'sale.send.to': 'Send til',
  'sale.send.replyTo': 'Svar til',
  'sale.send.asPdf': 'Send som PDF-vedlegg',
  'sale.send.asLink': 'Send som lenke',
  'sale.send.pdfHint': 'Kunden får dokumentet direkte i e-posten.',
  'sale.send.linkHint': 'Gir avleserstatus når kunden åpner dokumentet.',
  'sale.send.how': 'Hvordan skal dokumentet sendes?',
  'sale.send.newRecipient': 'Ny e-postadresse …',
  'sale.send.saveContact': 'Lagre som kontaktperson på {customer}',
  'sale.send.thisCustomer': 'kunden',
  'sale.send.contactName': 'Navn',
  'sale.send.contactNamePh': 'Kari Nordmann',
  'sale.send.contactRole': 'Rolle',
  'sale.send.contactRolePh': 'Regnskap',
  'sale.send.contactSaveFailed': 'Dokumentet ble sendt, men kontaktpersonen kunne ikke lagres.',
  'sale.send.emailPh': 'navn@eksempel.no',
  'sale.send.viewDocument': 'Se dokumentet',

  'sale.preview.sender': 'Avsender:',
  'sale.preview.invoiceNo': 'Fakturanr.:',
  'sale.preview.invoiceDate': 'Fakturadato:',
  'sale.preview.dueDate': 'Forfallsdato:',
  'sale.preview.ourRef': 'Vår referanse:',
  'sale.preview.theirRef': 'Deres referanse:',
  'sale.preview.comment': 'Kommentar:',
  'sale.preview.accountNo': 'Kontonr.:',
  'sale.preview.toPay': 'Å betale:',
  'sale.preview.net': 'Netto',
  'sale.preview.vat': 'MVA',
  'sale.preview.paid': 'Betalt',
  'sale.preview.toPayShort': 'Å betale',
  'sale.preview.receipt': 'Kvittering',
  'sale.preview.paymentHint': 'Vennligst oppgi fakturanummer ved betaling',
  'sale.preview.currencyNote': 'Alle beløp er oppgitt i {currency}',

  // -------------------------------------------------------- Nytt salg (i18n-opprydding)
  'sale.lines.fromDraftDescr': 'Overført fra utkast',
  'sale.att.maxSize': 'Vedlegg kan maks være {max}.', 'sale.att.addedOne': '1 vedlegg lagt til', 'sale.att.addedMany': '{count} vedlegg lagt til',
  'sale.comment.deleted': 'Kommentar slettet',
  'sale.comment.deleteFailed': 'Kunne ikke slette kommentaren.',
  'sale.comment.writeFirst': 'Skriv en kommentar først',
  'sale.comment.updated': 'Kommentar oppdatert',
  'sale.comment.saveFailed': 'Kunne ikke lagre kommentaren.',
  'sale.comment.alreadySaved': 'Kommentaren er allerede lagret',
  'sale.comment.saved': 'Kommentar lagret', 'sale.comment.backendUnavailable': 'Kommentarer er ikke koblet til backend.',
  'sale.det.offerDate': 'Tilbudsdato',
  'sale.det.orderDate': 'Ordredato',
  'sale.det.saleDate': 'Salgsdato',
  'sale.det.invoiceDateLabel': 'Fakturadato',
  'sale.det.validUntil': 'Gyldig til',
  'sale.det.dueDateLabel': 'Forfallsdato',

  // -------------------------------------------------- Nytt salg (andre halvdel)
  'sale.textLine.titleUpdate': 'Oppdater tekstlinje',
  'sale.textLine.titleNewHeading': 'Ny overskrift',
  'sale.textLine.titleNewText': 'Ny tekstlinje',
  'sale.textLine.update': 'Oppdater',
  'sale.textLine.typeLabel': 'Type',
  'sale.textLine.typeText': 'Tekstlinje',
  'sale.textLine.typeHeading': 'Overskrift',
  'sale.textLine.nameLabel': 'Navn',
  'sale.textLine.namePhHeading': 'F.eks. Arbeid',
  'sale.textLine.namePhText': 'F.eks. Produkt X',
  'sale.textLine.textLabel': 'Tekst',
  'sale.textLine.textPh': 'Valgfri tekst som vises under linjen',
  'sale.textLine.styleFor': 'Stil for {target}',
  'sale.textLine.boldShort': 'F',
  'sale.textLine.italicShort': 'K',
  'sale.textLine.useDivider': 'Bruk skillelinje',
  'sale.textLine.dividerHint': 'Vis linje under teksten i dokumentet.',
  'sale.textLine.searchPhHeading': 'Søk eller skriv overskrift...',
  'sale.textLine.searchPhText': 'Søk eller skriv tekstlinje...',
  'sale.textLine.noMatch': 'Ingen lagrede tekstlinjer matcher',
  'sale.textLine.addAsHeading': 'Legg til "{value}" som ny overskrift',
  'sale.textLine.addAsText': 'Legg til "{value}" som ny tekstlinje', 'sale.textLine.headingSaved': 'Overskrift lagret', 'sale.textLine.textSaved': 'Tekstlinje lagret', 'sale.textLine.headingAdded': 'Overskrift lagt til', 'sale.textLine.textAdded': 'Tekstlinje lagt til', 'sale.textLine.saveFailed': 'Kunne ikke lagre tekstlinjen.',

  'sale.det.durationMonth1': '1 måned', 'sale.det.durationMonth3': '3 måneder', 'sale.det.durationMonth6': '6 måneder',
  'sale.det.durationMonth12': '12 måneder',

  'sale.lines.typeProduct': 'Produktlinje',
  'sale.lines.typeSpacer': 'Mellomrom',
  'sale.lines.noText': 'Uten tekst',
  'sale.lines.qtyUnit': '{qty} stk',

  'sale.preview.receiptNoLabel': 'Kvitteringsnr.:',
  'sale.preview.quoteNoLabel': 'Tilbudsnr.:',
  'sale.preview.orderNoLabel': 'Ordrenr.:',
  'sale.preview.backToOther': 'Tilbake til Annet salg',
  'sale.preview.backToInvoice': 'Tilbake til faktura',
  'sale.preview.vatMoms': 'Moms',
  'sale.preview.continuesNextPage': 'Fortsetter på neste side',

  'sale.att.labelWithName': 'Vedlegg · {name}',
  'sale.att.dropHere': 'Slipp bilaget her',
  'sale.att.otherSaleHint': 'Annet salg er generelle salg utenom systemet - last opp et bilde eller PDF som dokumentasjon.',
  'sale.att.previewHint': 'For forhåndsvisning trykk på ett av dine vedlegg eller Se kvittering.',
  'sale.att.viewReceipt': 'Se kvittering',
  'sale.att.createReceipt': 'Lag kvittering',

  'sale.mode.subtitle': 'Velg en rolig stegvis flyt, eller behold alle feltene samlet på én side.',
  'sale.mode.stepsDesc': 'Kunde, detaljer, linjer og forhåndsvisning - én ting om gangen. Fin for nybegynnere.',
  'sale.mode.onePageDesc': 'Hele fakturaen samlet med levende forhåndsvisning. Raskt for de erfarne.',

  'sale.draft.noCustomer': 'Uten kunde',
  'sale.draft.noMatchesTitle': 'Ingen treff',
  'sale.draft.noMatchesText': 'Ingen utkast matcher søket.',
  'sale.draft.emptyText': 'Påbegynte salg lagres her når du trykker Lagre utkast.',
  'sale.draft.colSale': 'Salg',
  'sale.draft.noNumber': 'Uten nummer',
  'sale.draft.colDate': 'Dato',
  'sale.draft.colAmount': 'Beløp',
  'sale.draft.deleteFailed': 'Kunne ikke slette utkastet.',
  'sale.draft.saveFailed': 'Kunne ikke lagre utkastet.', 'sale.draft.deleteUnavailable': 'Sletting av utkast er ikke koblet til backend.', 'sale.draft.onlyDraftsDelete': 'Bare utkast kan slettes her', 'sale.draft.deleted': 'Utkast slettet', 'sale.draft.saveUnavailable': 'Utkastlagring er ikke koblet til backend.', 'sale.draft.savedToList': 'Utkastet er lagret i fakturalisten',

  'sale.create.invoice': 'Opprett faktura',
  'sale.create.quote': 'Opprett tilbud',
  'sale.create.order': 'Opprett ordrebekreftelse',
  'sale.create.other': 'Registrer salg',
  'sale.create.needMatchingPartials': 'Summen av delbetalingene må stemme med salgstotalen først',
  'sale.create.needLineOrAttachment': 'Legg til en linje eller et bilag først',
  'sale.create.needCustomerAndProduct': 'Velg en kunde og legg til minst ett produkt først',
  'sale.create.needCustomer': 'Velg en kunde først',
  'sale.create.needProduct': 'Legg til minst ett produkt først',
  'sale.create.receiptSendingBackground': 'Kvitteringen sendes i bakgrunnen',
  'sale.create.receiptSentEmail': 'Kvitteringen ble sendt på e-post.',
  'sale.create.recurringSaveFailed': 'Fakturaen ble opprettet, men den repeterende avtalen kunne ikke lagres.',
  'sale.create.createFailed': 'Kunne ikke opprette salget.',
  'sale.create.createdTitle': '{doc} {num} er opprettet.',
  'sale.create.saleCreatedBody': 'Salget er bokført. Du kan lagre kvittering, sende dokumentasjon til kunden eller lukke.',
  'sale.create.docCreatedBody': 'Du kan lagre {def} som PDF eller sende {pron} videre med e-post.',
  'sale.create.pdfReceiptLabel': 'PDF/Kvittering',
  'sale.create.pdfLabel': 'PDF',

  'sale.send.unavailableSale': 'Sending er ikke tilgjengelig for dette salget.',
  'sale.send.unavailableDocument': 'Sending er ikke tilgjengelig for dette dokumentet.',
  'sale.send.failed': 'Sendingen feilet.',
  'sale.send.customerFallback': 'Kunde',
  'sale.send.defaultContactRole': 'Standard kontakt',
  'sale.send.contactFallback': 'Kontaktperson',
  'sale.send.recipientFallback': 'Mottaker',
  'sale.send.receiptTitle': 'Send kvittering',
  'sale.send.howToSend': 'Hvordan vil du sende {doc}?',
  'sale.send.receiptEmailHint': 'Legg inn e-postadressen kvitteringen skal sendes til.',
  'sale.send.chooseDeliveryHint': 'Velg om kunden skal få en PDF i e-posten, eller en lenke Postplumma kan følge med på.',
  'sale.send.allCustomersInList': 'Alle kunder i listen ({count})',
  'sale.send.needEmailFirst': 'Legg inn e-post på kunden eller en kontaktperson før sending.',
  'sale.send.stepDraftPrep': 'Utkast klargjøres',
  'sale.send.stepArriving': 'Postplumma ankommer',
  'sale.send.stepSuccess': 'Suksess! Postplumma er på vei.',
  'sale.send.receiptReadyNoEmail': 'Kvitteringen er klar, men ingen e-post ble sendt.',
  'sale.send.sendingInBackground': '{doc} sendes i bakgrunnen',
  'sale.send.sentAsLinkShort': '{doc} ble sendt som lenke.',
  'sale.send.sentAsLinkTracked': '{doc} ble sendt som lenke. Du kan følge avleserstatus i fakturalisten.',
  'sale.send.sentAsEmail': '{doc} ble sendt på e-post.',
  'sale.send.readyNoEmail': '{doc} er klar, men ingen e-post ble sendt.',
  'sale.send.sentToRecipients': 'Sendt til {count} mottakere.',
  'sale.send.notProvided': 'Ikke oppgitt',
  'sale.send.spamTip': 'Tips: Hvis kunden ikke finner e-posten, be dem sjekke søppelpost/spam.',

  'sale.inboxPicker.tabInbox': 'Innboks ({count})',
  'sale.inboxPicker.tabDocumentation': 'Dokumentasjon ({count})',
  'sale.inboxPicker.searchDocumentation': 'Søk i dokumentasjon',
  'sale.inboxPicker.searchInbox': 'Søk i innboksen',
  'sale.inboxPicker.selectTip': 'Tips: Hold Shift for å velge flere på rad, eller Ctrl/Cmd for å velge enkeltvis.',
  'sale.inboxPicker.emptyDocumentation': 'Ingen dokumenter matcher søket.',
  'sale.inboxPicker.emptyInbox': 'Ingen bilag i innboksen matcher søket.',
  'sale.inboxPicker.fallbackReceipt': 'Bilag',
  'sale.inboxPicker.fallbackDocument': 'Dokument',
  'sale.inboxPicker.fallbackDocumentation': 'Dokumentasjon',
  'sale.lines.subscriptionPeriod': 'Abonnement - {{period}}', 'sale.lines.months12': '12 mnd', 'sale.lines.month1': '1 mnd', 'sale.lines.rentalPrice': 'Utleie - {{price}}',
  'sale.lines.addAsNewProduct': 'Legg til "{{value}}" som nytt produkt',
  'sale.lines.useDivider': 'Bruk skillelinje', 'sale.lines.dividerHint': 'Vis linje under denne raden i dokumentet.',
  'sale.preview.colDescription': 'Beskrivelse', 'sale.preview.colQty': 'Antall', 'sale.preview.colPrice': 'Pris', 'sale.preview.colDiscount': 'Rabatt', 'sale.preview.colSum': 'Sum',
  'sale.doc.invoiceName': 'Faktura', 'sale.doc.quoteName': 'Tilbud', 'sale.doc.orderConfirmationName': 'Ordrebekreftelse', 'sale.doc.creditNoteName': 'Kreditnota',
  'sale.draft.colType': 'Type',
  'sale.period.every14days': '14. dag', 'sale.det.dueDays': '{{count}} dager',
  'sale.lines.priceExVat': 'Pris eks. MVA', 'sale.lines.priceIncVat': 'Pris inkl. MVA', 'sale.lines.lineNumber': 'Linje {{n}}', 'sale.lines.pickProduct': 'Velg produkt', 'sale.lines.freeText': 'Fritekst', 'sale.lines.spacerHint': 'Tom linje vises som mellomrom i dokumentet.',
  'sale.lines.chooseLineType': 'Velg linjetype',
  'agreements.notSent': 'Ikke sendt', 'agreements.error.missingCustomerEmail': 'Kunden mangler e-postadresse. Legg inn e-post på kunden, så sendes fakturaen ved neste kjøring.', 'agreements.error.missingCustomer': 'Kunden finnes ikke lenger eller er arkivert. Velg en aktiv kunde for avtalen.', 'agreements.warning.missingCustomerEmail': 'Kunden mangler e-postadresse', 'agreements.warning.missingCustomerEmailHelp': 'Automatisk utsending krever e-postadresse. Legg den inn på kunden før neste fakturadato, ellers blir fakturaen ikke sendt.',
});
